module.exports = __webpack_public_path__ + "img/receipt-inverted.1946b052.png";